// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"931":"a797aeae7817c1b8","972":"7014f7f0fea831c7"}[chunkId] + ".css";
};